import React from 'react';

import { useRouter } from 'expo-router';
import { useIntl } from 'react-intl';
import { StyleSheet, Text, View } from 'react-native';

import { routes } from 'navigation/routing';
import { primitive } from 'styles/constants/primitives';

import { RedeemButton } from './styled';

export const RedeemCard = () => {
  const { formatMessage } = useIntl();
  const { navigate } = useRouter();

  const handleRedeemPress = () => {
    navigate(routes.rewards);
  };

  return (
    <View style={styles.redeemCard}>
      <View style={styles.redeemTextContainer}>
        <Text style={styles.redeemText}>
          {formatMessage({
            id: 'youveGotEnoughCrowns',
            defaultMessage: `You've got enough Crowns`,
          })}
        </Text>
        <Text style={styles.redeemText}>
          {formatMessage({ id: 'grabYourReward', defaultMessage: 'Grab your reward!' })}
        </Text>
      </View>
      <RedeemButton onPress={handleRedeemPress}>
        {formatMessage({ id: 'redeemNow', defaultMessage: 'Redeem Now' })}
      </RedeemButton>
    </View>
  );
};

export const styles = StyleSheet.create({
  redeemCard: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: primitive.spacing.$3,
    paddingHorizontal: primitive.spacing.$6,
    marginTop: primitive.spacing.$3,
    borderRadius: 12,
    backgroundColor: primitive.$white,
  },
  redeemTextContainer: {
    flex: 1,
  },
  redeemText: {
    fontSize: primitive.fontSizes.xs,
    fontFamily: primitive.fontFamily.$body,
    color: primitive.bk.$bbqBrown,
    lineHeight: 18,
  },
  redeemButton: {
    borderRadius: 20,
    paddingHorizontal: primitive.spacing.$5,
    paddingVertical: primitive.spacing.$2,
  },
});
